module.exports = __webpack_public_path__ + "img/lines.1f77a650.svg";